"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FdmFilesModule {
}
exports.FdmFilesModule = FdmFilesModule;
